import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FixedScrollWrapper from 'dpl/components/FixedScrollWrapper';
import OverlayModal from 'dpl/components/OverlayModal';
import MiniOverlayModalCloseButton from 'dpl/components/MiniOverlayModal/MiniOverlayModalCloseButton';


export default class MiniOverlayModal extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    hideCloseButton: PropTypes.bool,
    maxWidth: PropTypes.string,
    onCloseClick: PropTypes.func.isRequired,
    onOpen: PropTypes.func,
    scrollableContent: PropTypes.bool,
    zIndexClass: PropTypes.string,
    contentClassName: PropTypes.string,
    mobileCompact: PropTypes.bool // allow "peeking" transparent background
  };

  static defaultProps = {
    className: '',
    contentClassName: 'bg-white',
    hideCloseButton: false,
    maxWidth: '600px',
    onOpen: null,
    scrollableContent: false,
    zIndexClass: 'z-max',
    mobileCompact: false
  };

  ref = createRef();

  render() {
    const {
      className,
      maxWidth,
      onCloseClick,
      onOpen,
      children,
      scrollableContent,
      hideCloseButton,
      zIndexClass,
      contentClassName,
      mobileCompact
    } = this.props;

    const bgClassName = classnames(
      'pv12-md ph8-md flex items-center',
      {
        'h-100': scrollableContent,
        'min-h-100': !scrollableContent
      }
    );

    const contentsClassName = classnames(
      'MiniOverlayModal__contents w-100 relative-ns center br1',
      {
        'h-100': scrollableContent,
        relative: mobileCompact
      },
      contentClassName
    );

    /* eslint-disable jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events */
    return (
      <OverlayModal
        className={ className }
        hideCloseButton
        onClose={ onCloseClick }
        onOpen={ onOpen }
        zIndexClass={ zIndexClass }
      >
        <FixedScrollWrapper
          className={ classnames('MiniOverlayModal overflow-x-hidden h-100', {
            'MiniOverlayModal--mobileCompact': mobileCompact
          }) }
        >
          <div
            className={ bgClassName }
            ref={ this.ref }
            role="button"
            onClick={ e => (e.target === this.ref.current) && onCloseClick() }
          >
            <div
              className={ contentsClassName }
              style={ { maxWidth } }
            >
              { children }
              {
                !hideCloseButton &&
                  <MiniOverlayModalCloseButton onCloseClick={ onCloseClick } />
              }
            </div>
          </div>
        </FixedScrollWrapper>
      </OverlayModal>
    );
    /* eslint-enable jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events */
  }
}
